import { render, staticRenderFns } from "./facebook-connect-button.vue?vue&type=template&id=2dd4787e&scoped=true"
import script from "./facebook-connect-button.vue?vue&type=script&lang=js"
export * from "./facebook-connect-button.vue?vue&type=script&lang=js"
import style0 from "./facebook-connect-button.vue?vue&type=style&index=0&id=2dd4787e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd4787e",
  null
  
)

export default component.exports